(function () {
	'use strict';

  
  	var Cart = () => {
		const Toggle = window.themeCore.utils.Toggle;
		const cssClasses = window.themeCore.utils.cssClasses;
		const formToJSON = window.themeCore.utils.formToJSON;
		const on = window.themeCore.utils.on;
		const QuantityWidget = window.themeCore.utils.QuantityWidget;
		const UpsellSlider = window.themeCore.utils.UpsellSlider;
		const Preloder = window.themeCore.utils.Preloder;

		/**
		 * DOM selectors.
		 */
		const selectors = {
			section: '[data-section-type="cart-template"]',
			sectionDrawer: '[data-section-modification="drawer"]',
			upsellForm: "[data-cart-upsell]",
			container: ".js-cart-container",
			content: ".js-cart-content",
			buttonsContent: ".js-cart-footer-button",
			additionalButtons: ".js-cart-footer-additional-buttons",
			cartItem: "[data-cart-item]",
			quantity: ".js-quantity",
			quantityError: ".js-cart-item-error-message",
			remove: ".js-cart-item-remove",
			closeButton: ".js-cart-close-button",
			cartNoteField: ".js-cart-notes-field",
			cartDrawerNoteControlText: ".js-cart-drawer-note-control-text",
			cartFooterButtonMessage: ".js-cart-footer-button-message"
        };

		/**
		 * CSS selectors.
		 */
		const classes = {
			...cssClasses,
			empty: "is-empty"
		};

		/**
		 * Sections.
		 */
		let sections = [];

		/**
		 * Drawer sections.
		 */
		let drawers = [];

		/**
		 * Initialise component.
		 */
		function init() {
			setupDrawers();
			setupSections();
			setupEventListeners();

			if (window.themeCore.objects.settings.show_shipping_rates_calculator && window.Shopify) {
				initCartShippingCalculator();
			}
		}

		let hasErrors = false;

		/**
		 * Setup sections with drawers modification.
		 */
		function setupDrawers() {
			drawers = [...document.querySelectorAll(selectors.sectionDrawer)].map((section) => {
				const drawer = Toggle({
					toggleSelector: section.id,
					closeAccordionsOnHide: false
				});

				drawer.init();

				const initializedDrawer = {
					el: section,
					toggle: {
						open: () => drawer.open(section),
						close: () => drawer.close(section)
					}
				};

				setupDrawerEvents(initializedDrawer);

				return initializedDrawer;
			});
		}

		/**
		 * Setup event listeners section with drawers modification.
		 * @param {Object} drawer - drawer section.
		 */
		function setupDrawerEvents(drawer) {
			if (!drawer || !drawer.toggle) {
				return;
			}

			window.themeCore.EventBus.listen(`cart:drawer:${drawer.el.id}:open`, drawer.toggle.open);
			window.themeCore.EventBus.listen(`cart:drawer:${drawer.el.id}:close`, drawer.toggle.close);
		}

		/**
		 * Setup cart template sections.
		 */
		function setupSections() {
			sections = Array.from(document.querySelectorAll(selectors.section)).map((section) => ({
				el: section,
				id: section.dataset.sectionId,
				content: section.querySelector(selectors.content)
			}));

			sections.forEach((section) => {
				const quantityWidgets = Array.from(section.el.querySelectorAll(selectors.quantity));

				if (!quantityWidgets || !quantityWidgets.length) {
					section.quantityWidgets = [];
				} else {
					section.quantityWidgets = quantityWidgets.map((quantityEl) => {
						const widget = QuantityWidget(quantityEl, {
							onQuantityChange
						});

						return widget.init();
					});
				}

				const preloader = Preloder(section.el);
				if (preloader) {
					section.preloader = preloader.init();
				}

				const upsell = UpsellSlider(section.el);
				if (upsell) {
					section.upsell = upsell.init();
				}

				on("click", section.el, onRemoveButtonClick);
				on("submit", section.el, onUpsellFormSubmit);
			});

			window.themeCore.LazyLoadImages.init();
		}

		/**
		 * Setup global event listeners for sections.
		 */
		function setupEventListeners() {
			window.themeCore.EventBus.listen("cart:updated", onCartUpdated);
			window.themeCore.EventBus.listen("cart:refresh", refreshSections);
			window.themeCore.EventBus.listen("cart:drawer:open", openCartDrawer);
			window.themeCore.EventBus.listen("cart:drawer:refresh-and-open", refreshAndOpenCartDrawer);
			window.themeCore.EventBus.listen("cart:drawer:close", closeCartDrawer);
			document.addEventListener("click", (event) => event.target.closest(selectors.closeButton) && window.themeCore.EventBus.emit("cart:drawer:close"));
			document.addEventListener("change", saveCartNoteValue);
		}

		/**
		 * Save cart note value.
		 */
		async function saveCartNoteValue(event) {
			const cartNotesField = event.target.closest(selectors.cartNoteField);
			const cartNoteControlText = document.querySelector(selectors.cartDrawerNoteControlText);

			if (!cartNotesField) return;

			showPreloaders();

			try {
				await window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART, {
					note: cartNotesField.value
				});
			} catch (error) {
				console.log(error);
			} finally {
				hidePreloaders();

				if (cartNoteControlText) {
					if (cartNotesField.value !== "") {
						cartNoteControlText.textContent = window.themeCore.translations.get("cart.general.edit_note");
					} else {
						cartNoteControlText.textContent = window.themeCore.translations.get("cart.general.note");
					}
				}
			}
		}

		/**
		 * Get cart template sections ids.
		 * @return {Array}
		 */
		function getSectionsIds() {
			return sections.map((section) => section.id);
		}

		/**
		 * Get cart template sections DOMs.
		 * @return {Promise}
		 */
		function getCartSectionsDOMs() {
			const ids = getSectionsIds();

			const requestURL = new URL(window.location.href);
			requestURL.searchParams.set("sections", ids.join(","));
			requestURL.searchParams.set("lazyload", "false");

			return fetch(requestURL.href).then((response) => response.json());
		}

		/**
		 * Open cart drawer.
		 * @param {*} data - Payload to send to listeners.
		 */
		function openCartDrawer(data) {
			if (data && data.id) {
				window.themeCore.EventBus.emit(`cart:drawer:${data.id}:open`);
				return; 
			}

			const firstAvailableCartDrawer = drawers.find((drawer) => drawer.toggle && drawer.toggle.open);
          
			if (firstAvailableCartDrawer) {
				firstAvailableCartDrawer.toggle.open();
			}

		}

		/**
		 * Refresh and open cart drawer.
		 * @param {*} data - Payload to send to listeners.
		 */
		function refreshAndOpenCartDrawer(data) {
			refreshSections().then(() => {
				openCartDrawer(data);
			});
		}

		/**
		 * Close cart drawer.
		 * @param {*} data - Payload to send to listeners.
		 */
		function closeCartDrawer(data) {
			if (data && data.id) {
				window.themeCore.EventBus.emit(`cart:drawer:${data.id}:close`);
				return;
			}

			drawers.forEach((drawer) => {
				if (drawer.toggle && drawer.toggle.close) {
					drawer.toggle.close();
				}
			});
		}

		/**
		 * Show preloaders in cart template sections.
		 */
		function showPreloaders() {
			sections.forEach((section) => {
				if (section.preloader) {
					section.preloader.show();
				}
			});
		}

		/**
		 * Hide preloaders in cart template sections.
		 */
		function hidePreloaders() {
			sections.forEach((section) => {
				if (section.preloader) {
					section.preloader.hide();
				}
			});
		}

		/**
		 * Refresh cart template sections.
		 * @param {Object} sectionsResource - Sections DOMs.
		 * @returns {Promise}
		 */
		async function refreshSections(sectionsResource = null) {
			const resource = !(sectionsResource && Object.keys(sectionsResource).length === 0 && Object.getPrototypeOf(sectionsResource) === Object.prototype)
				? sectionsResource
				: await getCartSectionsDOMs();

			if (!resource) {
				return false;
			}

			sections.map((section) => {
				const template = new DOMParser().parseFromString(resource[section.id], "text/html");

				const updatedSection = template.querySelector(selectors.section);
				const content = template.querySelector(selectors.content);
				const buttonsContent = template.querySelector(selectors.buttonsContent);
				const additionalButtons = template.querySelector(selectors.additionalButtons);
				const cartFooterButtonMessage = template.querySelector(selectors.cartFooterButtonMessage);

				if (!updatedSection || !content) {
					return;
				}

				section.el.classList.toggle(classes.empty, updatedSection.classList.contains(classes.empty));

				const sectionContent = section.el.querySelector(selectors.content);

				if (!sectionContent) {
					return;
				}

				if (buttonsContent) {
					const sectionButtonsContent = section.el.querySelector(selectors.buttonsContent);

					if (sectionButtonsContent && sectionButtonsContent.innerHTML !== buttonsContent.innerHTML) {
						sectionButtonsContent.innerHTML = buttonsContent.innerHTML;
					}
				}

				if (cartFooterButtonMessage) {
					const sectionCartFooterButtonMessage = section.el.querySelector(selectors.cartFooterButtonMessage);

					if (sectionCartFooterButtonMessage && sectionCartFooterButtonMessage.outerHTML !== cartFooterButtonMessage.outerHTML) {
						sectionCartFooterButtonMessage.outerHTML = cartFooterButtonMessage.outerHTML;
					}
				}

				if (additionalButtons) {
					const sectionAdditionalButtons = section.el.querySelector(selectors.additionalButtons);

					if (sectionAdditionalButtons && sectionAdditionalButtons.innerHTML !== additionalButtons.innerHTML) {
						sectionAdditionalButtons.classList.toggle(classes.hidden, additionalButtons.classList.contains(classes.hidden));
					}
				}

				sectionContent.innerHTML = content.innerHTML;
			});

			setupSections();
		}

		/**
		 * Emit an event in the eventBus when the quick view button is clicked.
		 * @param {String} handle - Product handle for quick view modal.
		 * @param {String} variantId - Product variant for quick view modal.
		 */
		function emitQuickViewClickEvent(handle, variantId) {
			window.themeCore.EventBus.emit("product-card:quick-view:clicked", {
				productHandle: handle,
				variant: variantId
			});
		}

		/**
		 * Add upsell product into cart.
		 * @param {String} variantId - Product variant.
		 */
		async function emitAddToCard(variantId, quantity) {
			try {
				await window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.ADD_TO_CART, {
					id: variantId,
					quantity: quantity
				});
			} catch (error) {
				return error && error.description;
			}
		}

		/**
		 * Quantity change in quantity widget event handler.
		 * @param {Object} widget - Quantity widget instance.
		 */
		function onQuantityChange(widget) {
			if (!widget || !widget.controls || !widget.controls.input) {
				return;
			}

			showPreloaders();

			const input = widget.controls.input;
			const key = input.dataset.itemKey;
			const quantity = widget.quantity.value;

			const sectionsIds = getSectionsIds().join(",");

			window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.CHANGE_CART_ITEM_QUANTITY, key, quantity, sectionsIds)
				.then(async (cart) => {
					let item = cart.items.find((item) => item.key === key);

					if (item && quantity !== item.quantity) {
						const description = window.themeCore.translations.get("cart.errors.quantity", {
							count: item.quantity,
							title: item.title
						});

						hasErrors = true;

						setTimeout(() => {
							hasErrors = false;
						}, 0);

						throw { description };
					}
				})
				.catch((error) => {
					onQuantityError(widget, error);
				})
				.finally(() => {
					hidePreloaders();
				});
		}

		/**
		 * Remove button click event handler.
		 * @param {Event} event - Click event.
		 */
		function onRemoveButtonClick(event) {
			const removeButton = event.target.closest(selectors.remove);
			if (!removeButton) {
				return;
			}

			event.preventDefault();
			showPreloaders();

			const sectionsIds = getSectionsIds().join(",");

			const key = removeButton.dataset.itemKey;
			window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.REMOVE_CART_ITEM, key, sectionsIds).finally(() => {
				hidePreloaders();
			});
		}

		/**
		 * Quantity error event handler.
		 * @param {Object} quantityWidget - Quantity widget instance.
		 * @param {Object} error - Error.
		 */
		function onQuantityError(quantityWidget, error) {
			if (!quantityWidget || !error) {
				return;
			}

			quantityWidget.rollbackValue();

			const cartItem = quantityWidget.widget.closest(selectors.cartItem);
			if (!cartItem) {
				return;
			}

			const errorEl = cartItem.querySelector(selectors.quantityError);
			errorEl.innerHTML = error.message;
		}

		/**
		 * Upsell form submit event handler.
		 * @param {Event} event - Submit event.
		 */
		function onUpsellFormSubmit(event) {
			const form = event.target.closest(selectors.upsellForm);
			if (!form) {
				return;
			}

			event.preventDefault();

			const formData = formToJSON(form);
			const { id, handle, singleVariant, quantity } = formData;

			JSON.parse(singleVariant) ? emitAddToCard(id, Number(quantity)) : emitQuickViewClickEvent(handle, id);
		}

		/**
		 * Cart updated event handler.
		 * @param {Object} data
		 */
		function onCartUpdated(data) {
			let resource = null;
			if (data) {
				resource = data.sections;
			}

			if (!hasErrors) {
				refreshSections(resource).then(() => {
					const isNotificationEnable = window.themeCore.objects.settings.show_cart_notification;
					const isOpenCart = !data.params.some((param) => param.noOpen);
                  
					if (!JSON.parse(isNotificationEnable) && isOpenCart) {
						window.themeCore.EventBus.emit("cart:drawer:open");
                        // [MIT] Free Product on Threshold 
                        mitFreeProductFunction()
					}
				});
			}
		}

		function initCartShippingCalculator() {
			new window.Shopify.CountryProvinceSelector("cart-address-country", "cart-address-province", {
				hideElement: "cart-address-province-container"
			});

			const submitRatesButton = document.querySelector(".js-get-ship-rates");
			const formElements = document.querySelectorAll(".js-ship-rate-field");
			const ratesCountry = document.getElementById("cart-address-country");
			const ratesProvince = document.getElementById("cart-address-province");
			const ratesZIP = document.getElementById("cart-address-zip");
			const responseWrapper = document.getElementById("cart-rates-wrapper");

			let shippingAddress = {
				country: "",
				province: "",
				zip: ""
			};

			formElements.forEach(function (field) {
				let eventName = "keyup";

				if (field.tagName === "SELECT") {
					eventName = "change";
				}

				field.addEventListener(eventName, () => {
					removeError(field);
				});
			});

			submitRatesButton.addEventListener("click", function (e) {
				e.preventDefault();

				submitRatesButton.setAttribute("disabled", "");

				shippingAddress.country = ratesCountry.value || "";
				shippingAddress.province = ratesProvince.value || "";
				shippingAddress.zip = ratesZIP.value || "";

				const params = `shipping_address[country]=${shippingAddress.country}&shipping_address[province]=${shippingAddress.province}&shipping_address[zip]=${shippingAddress.zip}`;
				const url = encodeURI(`${params}`);

				try {
					fetch(`/cart/prepare_shipping_rates.json?${url}`, {
						method: "POST"
					})
						.then((response) => response.text())
						.then((state) => {
							const parsedState = JSON.parse(state);

							if (typeof parsedState === "object" && parsedState !== null) {
								Object.entries(parsedState).forEach(([key, value]) => {
									const fieldElement = document.getElementById(`cart-address-${key}`);
									const errorElement = document.getElementById(`error-cart-address-${key}`);

									if (!errorElement) {
										return;
									}

									errorElement.textContent = `${value}`;
									errorElement.classList.remove(cssClasses.hidden);

									fieldElement.setAttribute("aria_invalid", "true");
									fieldElement.setAttribute("aria_describedby", `error-cart-address-${key}`);
								});

								submitRatesButton.removeAttribute("disabled");
								return;
							}

							fetch(`/cart/async_shipping_rates.json?${url}`)
								.then((response) => response.text())
								.then((responseText) => {
									const parsedResponse = JSON.parse(responseText);
									const shippingRates = parsedResponse ? parsedResponse.shipping_rates : [];

									submitRatesButton.removeAttribute("disabled");

									if (shippingRates.length > 0) {
										responseWrapper.innerHTML = "";
										const ulElement = document.createElement("ul");
										ulElement.classList.add("cart-shipping-calc__rate-list");

										shippingRates.forEach((rate) => {
											const liElement = document.createElement("li");
											ulElement.appendChild(liElement);
											const name = rate.name;
											let price = rate.price;
											const deliveryDays = rate.delivery_days;
											let estimateTime = "";

											if (price === "0.00") {
												price = window.themeCore.translations.get("cart.shipping_rates.price_free");
											} else {
												price = `${window.themeCore.utils.formatMoney(
												price.includes(".") ? price : price + ".00",
												window.themeCore.objects.shop.money_format
											)}`;
											}

											if (deliveryDays.length) {
												deliveryDays.forEach((t, i) => {
													estimateTime = i === 0 ? t : `${estimateTime}-${t}`;
												});

												estimateTime = `<span>${estimateTime} days</span>`;
											}

											liElement.innerHTML = `<span class="cart-shipping-calc__rate-name">${name}:</span> ${estimateTime} ${price}`;
										});

										responseWrapper.appendChild(ulElement);
									} else {
										responseWrapper.innerHTML = window.themeCore.translations.get("cart.shipping_rates.no_shipping");
									}
								});
						});
				} catch (e) {
					console.log(e, "Error with shipping rates");
				}
			});

			function removeError(formField) {
				if (!formField) {
					return;
				}

				const errorType = formField.id.split("cart-address-")[1];
				const errorMessage = document.getElementById(`error-cart-address-${errorType}`);

				formField.removeAttribute("aria_invalid");
				formField.removeAttribute("aria_describedby");

				if (errorMessage) {
					errorMessage.classList.add(cssClasses.hidden);
					errorMessage.textContent = "";
				}
			}
		}

		/**
		 * Expose public interface.
		 */
		return Object.freeze({
			init
		});
	};

	const action = () => {
		window.themeCore.Cart = window.themeCore.Cart || Cart();
		window.themeCore.utils.register(window.themeCore.Cart, "cart-template");
	};

	if (window.themeCore && window.themeCore.loaded) {
		action();
	} else {
		document.addEventListener("theme:all:loaded", action);
	}

})();


// [MIT] Free Product on Threshold
let mitFreeProductCheck = $('#mit-free-product-true').attr("value");
let mitFreeProd = $('#mit-free-product').attr("value");
let mitFreeProdTitle = $('#mit-free-product-title').attr("value");
let mitThreshold = parseFloat($('#mit-free-product-threshold').attr("value"));
mitThreshold = mitThreshold * 100;

function mitFreeProductFunction() {
  if (mitFreeProductCheck === "true") {
      let mitFreeProductExists = false;
  
      function checkCartAndUpdateProduct() {
          let mitTotalJs = $('.mit-subtotal').text().replace(/\s+|€|,/g, "");
          mitTotalJs = parseFloat(mitTotalJs);

          // Check if the free product already exists in the cart
          $(".cart-item__details-title").each(function() {
              if ($(this).text().trim() === mitFreeProdTitle.trim()) {
                  mitFreeProductExists = true;
              }
          });
  
          // Perform AJAX call to get cart data and update based on the current cart status
          $.ajax({
              url: '/cart.js',
              method: 'GET',
              dataType: 'json',
              success: function(cartData) {
                  let productAlreadyInCart = cartData.items.some(item => item.id == mitFreeProd);


                  if (mitTotalJs < mitThreshold) {
                    console.log('below')
                      // Remove the product if below threshold and it exists
                      $.ajax({
                          url: '/cart/change.js',
                          method: 'POST',
                          dataType: 'json',
                          data: {
                              quantity: 0,
                              id: mitFreeProd
                          }
                      }).done(() => {
                          window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART);
                          mitFreeProductExists = false; // Update status
                      })
                  } else if (mitTotalJs >= mitThreshold && !productAlreadyInCart && !mitFreeProductExists) {
                      // Add the product if above threshold and it does not exist
                      $.ajax({
                          url: '/cart/add.js',
                          method: 'POST',
                          dataType: 'json',
                          data: {
                              quantity: 1,
                              id: mitFreeProd
                          }
                      }).done(() => {
                          window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART);
                          mitFreeProductExists = true; // Update status
                      })
                  }
              },
              error: function() {
                  console.error("Failed to fetch cart data.");
              }
          });
      }
  
      // Use a slight delay to handle quick cart updates or initial load
      setTimeout(checkCartAndUpdateProduct, 1000);
  }
}
